<template>
  <button
    :title="
      isDisabledAnimations ? t('animations.enable') : t('animations.disable')
    "
    :aria-pressed="isDisabledAnimations ? true : undefined"
    class="animation-switcher"
    @click="toggleAnimationsMode"
  >
    <DisableAnimationsIcon class="icon" />
  </button>
</template>

<script lang="ts" setup>
import DisableAnimationsIcon from '@/assets/icons/disable-animations.svg?component'
import { useDisabledAnimations } from '@/state/a11yState'

const { t } = useI18n()
const isDisabledAnimations = useDisabledAnimations()

function toggleAnimationsMode() {
  isDisabledAnimations.value = !isDisabledAnimations.value
}
</script>

<style lang="scss" scoped>
.animation-switcher {
  @include focus-visible;
  display: flex;

  .icon {
    --background-color: #{$beige};
    color: $dark-brown;

    .dark-mode & {
      --background-color: #{$dark-brown};
      color: $beige;
    }
  }
}
</style>
